/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询角色列表
         * @param data
         * @return {*}
         */
        queryRoleList (data) {
            return http.json({
                url: '/sys/role/queryAll',
                data
            })
        },
        /**
         * 查询角色列表树
         * @param data
         * @return {*}
         */
        queryRoleTree (data) {
            return http.json({
                url: '/sys/role/queryAllTree',
                data
            })
        },

        /**
         * 查询角色详情
         * @param data
         * @return {*}
         */
        getRoleInfo (data){
            return http({
                url: `/sys/role/get?id=${data.id}`,
                method: 'post'
            });
        },

        /**
         * 保存角色信息
         * @param data
         * @return {*}
         */
        saveRoleInfo (data){
            return http.json({
                url: '/sys/role/saveAndBinding',
                data
            });
        },

        /**
         * 删除角色信息
         * @param data
         */
        removeRole (data){
            return http.json({
                url: '/sys/role/delete',
                data
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/api/role.js